import React from 'react';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

export default class Alerta extends React.Component {
    constructor(props) {
        super(props);
        this.createNotification = this.createNotification.bind(this);
    }

    createNotification(){
        var tipo = document.getElementById('inp_Tipo').value,
            msg = document.getElementById('inp_Mssg').value,
            ttl = document.getElementById('inp_Ttl').value;
            switch (tipo) {
            case 'info':
                NotificationManager.info(msg);
                break;
            case 'success':
                NotificationManager.success(msg, ttl);
                break;
            case 'warning':
                NotificationManager.warning(msg, ttl, 3000);
                break;
            case 'error':
                NotificationManager.error(msg, ttl, 5000, () => {
                });
                break;
            
            default:
                
            break;

            }
    };
   
    render() {
      return (
        <div>
            <input type="hidden" id="inp_Tipo" value="info"/>
            <input type="hidden" id="inp_Mssg" value="Mensaje"/>
            <input type="hidden" id="inp_Ttl" value="titulo"/>
            <button className='Hide_All' onClick={(e)=>this.createNotification(e)} id="btn_Alert"/>
            <NotificationContainer/>
        </div>
      );
    }
  }
   

